import { isValueDefined } from "@mm-products/java-multima-framework";
import dayjs, { ConfigType, Dayjs, isDayjs } from "dayjs";
import _ from "lodash";

export function formatDateObjectNicely(dateObject: dayjs.Dayjs | undefined | null, withTime = false) {
    if (withTime) {
        return dateObject?.format("LLL");
    }
    return dateObject?.format("LL");
}

export function fromNowStr(dateObject: string | undefined | null, withoutSuffix?: boolean) {
    const parsedDateObject = stringToDateObject(dateObject);
    return parsedDateObject?.fromNow(withoutSuffix);
}
export function formatDateObjectNicelyStr(dateString: string | undefined | null, withTime = false) {
    const parsedDateObject = stringToDateObject(dateString);
    return formatDateObjectNicely(parsedDateObject, withTime);
}

export const dateForTaxLocalDate = (dateObject: dayjs.Dayjs | null | undefined) => {
    return dateObject?.format("YYYY-MM-DD");
};

export const dateForTaxWithTime = (dateObject: dayjs.Dayjs | null | undefined) => {
    return dateObject?.toISOString();
};

export const dateForRecogniser = (dateObject: dayjs.Dayjs | null | undefined) => {
    return dateObject?.format("YYYY-MM-DDTHH:mm:ss");
};

export const isDateObject = (dateObject: dayjs.Dayjs | null | undefined | unknown): dateObject is Dayjs => isDayjs(dateObject);
export const isDateObjectValid = (dateObject: dayjs.Dayjs | null | undefined | unknown): dateObject is Dayjs =>
    (isDateObject(dateObject) && dateObject.isValid()) ?? false;

export const stringToDateObject = (value: ConfigType | null | undefined): Dayjs | undefined => {
    if (isValueDefined(value)) {
        const parsetValue = dayjs(value);
        if (parsetValue.isValid()) {
            return parsetValue;
        }
    }
    return undefined;
};

export const toDateObject = (dateObject: dayjs.Dayjs | null | undefined | unknown) => {
    if (isDateObjectValid(dateObject)) {
        return dayjs(dateObject);
    }
    return undefined;
};

export const convertToJavaLocalDate = (date: Date) => {
    const month = _.padStart((date.getMonth() + 1).toString(), 2, "0");
    const day = _.padStart(date.getDate().toString(), 2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
};


export const newDateObjectInstance = () => dayjs();
